<template>
  <div class="v-text-field__details mt-n4">
    <div class="v-messages theme--light">
      <div class="v-messages__wrapper ml-8">
        <div class="mb-0 v-messages__message" v-html="htmlDescription">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomFieldDescription",
  props: ['htmlDescription'],
  data: () => ({
  }),
  methods: {
  },
  created() {
  }
}
</script>
